import { title } from "assets/jss/material-kit-react.jsx";

const productStyle = {
 container : {
    paddingRight: '15px',
    paddingLeft: '15px',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '100%',
    '@media (min-width: 576px)': {
        maxWidth: '540px'
    },
    '@media (min-width: 768px)': {
        maxWidth: '750px'
    },
    '@media (min-width: 992px)': {
        maxWidth: '970px'
    },
    '@media (min-width: 1200px)': {
        maxWidth: '1170px'
    }
},
 
  section: {
    textAlign: "center"
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "10px",
    minHeight: "32px",
    textDecoration: "none"
  },
  description: {
    color: "#999"
  }
};

export default productStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx